import http from '../http';

/**
 * Create simple order
 * @param {Object} param - Order creation parameters
 * @param {Function} callBack - Callback function after successful creation
 */
export const createSimpleOrder = async (param = {}, callBack) => {
    await http.post(`/newapi/tax/pay/createSimpleOrder`, param).then(({ data: res }) => {
      callBack && callBack(res);
    });
};

/**
 * Add withdrawal request
 * @param {Object} param - Withdrawal parameters object
 * @param {Function} callBack - Callback function after successful request
 */
export const addWithdraw = async (param = {}, callBack) => {
    await http.post(`/newapi/tax/user/withdraw/addWithdraw`, param).then(({ data: res }) => {
      callBack && callBack(res);
    });
};

/**
 * Get withdrawal record list
 * @param {Object} param - Query parameters object
 * @param {Function} callBack - Callback function after successful retrieval
 */
export const withdrawRecord = async (param = {}, callBack) => {
    await http.post(`/newapi/tax/user/withdraw/list`, param).then(({ data: res }) => {
      callBack && callBack(res);
    });
};

/**
 * Query invitation information
 * @param {Object} param - Query parameters object
 * @param {Function} callBack - Callback function after query completion
 */
export const queryInviteInfo = async (param = {}, callBack) => {
    await http.post(`/newapi/tax/user/invite/queryInviteInfo`, param).then(({ data: res }) => {
      callBack && callBack(res);
    });
};

/**
 * Audit withdrawal request
 * @param {Object} param - Audit parameters object
 * @param {Function} callBack - Callback function after successful audit
 */
export const auditWithdraw = async (param = {}, callBack) => {
  await http.post(`/newapi/tax/user/withdraw/auditWithdraw`, param).then(({ data: res }) => {
    callBack && callBack(res);
  });
};

/**
 * Query invitation information by code
 * @param {Object} param - Query parameters object
 * @param {Function} callBack - Callback function after query completion
 */
export const queryInviteInfoByCode = async (param = {}, callBack) => {
  await http.post(`/newapi/tax/user/invite/queryInviteInfoByCode/${param.inviteCode}`, param).then(({ data: res }) => {
    callBack && callBack(res);
  });
};